import { PostUserEventRequest, UserEventType } from '@finance-lab/utils/types'
import ApiBase from './Api'

const USER_EVENT_API_PATHS = {
    EVENTLOG: '/eventlog',
}

const ThumbmarkProm = import('@thumbmarkjs/thumbmarkjs')

class UserEventApi extends ApiBase {
    async logEvent(eventType: UserEventType, eventDetails: Record<string, unknown> = {}) {
        const { Thumbmark } = await ThumbmarkProm

        const tm = new Thumbmark({
            api_key: import.meta.env.VITE_THUMBMARK_API_KEY,
            cache_lifetime_in_ms: 74 * 3600 * 1000,
        })
        const result = await tm.get()
        const thumbmark = result

        const response = await this._postRequest<PostUserEventRequest>(USER_EVENT_API_PATHS.EVENTLOG, {
            eventType: eventType,
            tm: {
                visitorId: thumbmark.visitorId ?? thumbmark.thumbmark,
                metadata: {
                    components: thumbmark.components,
                    info: thumbmark.info,
                },
            },
            ...eventDetails,
        })
        return response
    }
}

export default UserEventApi
